let soundTimeout: ReturnType<typeof setTimeout> | null = null;

export const playSound = (sound: string, delay = 100) => {
  if (soundTimeout) {
    clearTimeout(soundTimeout);
  }

  soundTimeout = setTimeout(() => {
    const audio = new Audio(sound);
    audio.play();
  }, delay);
};